import React, { useEffect, useState } from "react";
import "./Experience.css";
import rag from "./projects/rag.png";
import cdac from "./projects/cdac.png";
import finzen from "./projects/finzen.png";
import MotionFromRight from "./MotionFromRight";
import { IoLogoAppleAppstore, IoLogoGooglePlaystore } from "react-icons/io5";
import { AiOutlineLink } from "react-icons/ai";

const Experience = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredImg, setIsHoveredImg] = useState(false);

  function atvImg() {
    var d = document,
      de = d.documentElement,
      bd = d.getElementsByTagName("body")[0],
      htm = d.getElementsByTagName("html")[0],
      win = window,
      imgs = d.querySelectorAll(".atvImg"),
      totalImgs = imgs.length,
      supportsTouch = "ontouchstart" in win || navigator.msMaxTouchPoints;

    if (totalImgs <= 0) {
      return;
    }

    for (var l = 0; l < totalImgs; l++) {
      var thisImg = imgs[l],
        layerElems = thisImg.querySelectorAll(".atvImg-layer"),
        totalLayerElems = layerElems.length;

      if (totalLayerElems <= 0) {
        continue;
      }

      while (thisImg.firstChild) {
        thisImg.removeChild(thisImg.firstChild);
      }

      var containerHTML = d.createElement("div"),
        shineHTML = d.createElement("div"),
        shadowHTML = d.createElement("div"),
        layersHTML = d.createElement("div"),
        layers = [];

      thisImg.id = "atvImg__" + l;
      containerHTML.className = "atvImg-container";
      shineHTML.className = "atvImg-shine";
      shadowHTML.className = "atvImg-shadow";
      layersHTML.className = "atvImg-layers";

      for (var i = 0; i < totalLayerElems; i++) {
        var layer = d.createElement("div"),
          imgSrc = layerElems[i].getAttribute("data-img");

        layer.className = "atvImg-rendered-layer";
        layer.setAttribute("data-layer", i);
        layer.style.backgroundImage = "url(" + imgSrc + ")";
        layersHTML.appendChild(layer);

        layers.push(layer);
      }

      containerHTML.appendChild(shadowHTML);
      containerHTML.appendChild(layersHTML);
      containerHTML.appendChild(shineHTML);
      thisImg.appendChild(containerHTML);

      var w = thisImg.clientWidth || thisImg.offsetWidth || thisImg.scrollWidth;
      thisImg.style.transform = "perspective(" + w * 3 + "px)";

      if (supportsTouch) {
        win.preventScroll = false;

        (function (_thisImg, _layers, _totalLayers, _shine) {
          thisImg.addEventListener("touchmove", function (e) {
            if (win.preventScroll) {
              e.preventDefault();
            }
            processMovement(e, true, _thisImg, _layers, _totalLayers, _shine);
          });
          thisImg.addEventListener("touchstart", function (e) {
            win.preventScroll = true;
            processEnter(e, _thisImg);
          });
          thisImg.addEventListener("touchend", function (e) {
            win.preventScroll = false;
            processExit(e, _thisImg, _layers, _totalLayers, _shine);
          });
        })(thisImg, layers, totalLayerElems, shineHTML);
      } else {
        (function (_thisImg, _layers, _totalLayers, _shine) {
          thisImg.addEventListener("mousemove", function (e) {
            processMovement(e, false, _thisImg, _layers, _totalLayers, _shine);
          });
          thisImg.addEventListener("mouseenter", function (e) {
            processEnter(e, _thisImg);
          });
          thisImg.addEventListener("mouseleave", function (e) {
            processExit(e, _thisImg, _layers, _totalLayers, _shine);
          });
        })(thisImg, layers, totalLayerElems, shineHTML);
      }
    }

    function processMovement(
      e,
      touchEnabled,
      elem,
      layers,
      totalLayers,
      shine
    ) {
      var bdst = bd.scrollTop || htm.scrollTop,
        bdsl = bd.scrollLeft,
        pageX = touchEnabled ? e.touches[0].pageX : e.pageX,
        pageY = touchEnabled ? e.touches[0].pageY : e.pageY,
        offsets = elem.getBoundingClientRect(),
        w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth,
        h = elem.clientHeight || elem.offsetHeight || elem.scrollHeight,
        wMultiple = 320 / w,
        offsetX = 0.52 - (pageX - offsets.left - bdsl) / w,
        offsetY = 0.52 - (pageY - offsets.top - bdst) / h,
        dy = pageY - offsets.top - bdst - h / 2,
        dx = pageX - offsets.left - bdsl - w / 2,
        yRotate = (offsetX - dx) * (0.07 * wMultiple),
        xRotate = (dy - offsetY) * (0.1 * wMultiple),
        imgCSS = "rotateX(" + xRotate + "deg) rotateY(" + yRotate + "deg)",
        arad = Math.atan2(dy, dx),
        angle = (arad * 180) / Math.PI - 90;

      if (angle < 0) {
        angle = angle + 360;
      }

      if (elem.firstChild.className.indexOf(" over") != -1) {
        imgCSS += " scale3d(1.07,1.07,1.07)";
      }
      elem.firstChild.style.transform = imgCSS;

      shine.style.background =
        "linear-gradient(" +
        angle +
        "deg, rgba(255,255,255," +
        ((pageY - offsets.top - bdst) / h) * 0.4 +
        ") 0%,rgba(255,255,255,0) 80%)";
      shine.style.transform =
        "translateX(" +
        offsetX * totalLayers -
        0.1 +
        "px) translateY(" +
        offsetY * totalLayers -
        0.1 +
        "px)";

      var revNum = totalLayers;
      for (var ly = 0; ly < totalLayers; ly++) {
        layers[ly].style.transform =
          "translateX(" +
          offsetX * revNum * ((ly * 2.5) / wMultiple) +
          "px) translateY(" +
          offsetY * totalLayers * ((ly * 2.5) / wMultiple) +
          "px)";
        revNum--;
      }
    }

    function processEnter(e, elem) {
      elem.firstChild.className += " over";
    }

    function processExit(e, elem, layers, totalLayers, shine) {
      var container = elem.firstChild;

      container.className = container.className.replace(" over", "");
      container.style.transform = "";
      shine.style.cssText = "";

      for (var ly = 0; ly < totalLayers; ly++) {
        layers[ly].style.transform = "";
      }
    }
  }
  useEffect(() => {
    atvImg();
  }, []);
  useEffect(() => {
    const circle = document.getElementById("circled");
    const circleStyle = circle?.style;
    function handleMouseMove(e) {
      window.requestAnimationFrame(() => {
        if (isHovered && circleStyle) {
          circleStyle.top = `${e.clientY - circle?.offsetHeight / 2}px`;
          circleStyle.left = `${e.clientX - circle?.offsetWidth / 2}px`;
        }
      });
    }

    document.addEventListener("mousemove", handleMouseMove);
    console.log("mousemove");
    const circledElement = document.getElementById("circled");
    if (circledElement) {
      if (isHoveredImg) {
        circledElement.classList.add("change");
        circledElement.style.background = "transparent";
      } else {
        circledElement.style.background = "white";
        circledElement.classList.remove("change");
      }
    }
    // Cleanup function to remove event listener when component unmounts
  }, [isHovered, isHoveredImg]);
  //   console.log(isHovered);

  const experience = [
    {
      position: "AI Software Developer, Intern",
      company: "HackeroX",
      companyLink: "https://hackerox.com/",
      location: "Mumbai",
      dates: "Jan 2024 - Mar 2024",
      responsibilities: [
        "Leading the design and development of customizable AI chatbot application for company data to perform transactions on external systems giving citations with output.",
        "It utilizes a React + Typescript frontend and python Quart based backend, giving citations with output.",
        "Created functionality to give custom output based on data and query , enabled communication with external databases using function calling in OpenAI.",
      ],
      image: rag,
      techUsed: [
        "https://img.shields.io/badge/azure-%230072C6.svg?style=for-the-badge&logo=microsoftazure&logoColor=white",
        "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
        "https://img.shields.io/badge/Quart-679436?style=for-the-badge&logo=quart&logoColor=white",
        "https://img.shields.io/badge/TypeScript-007ACC?style=for-the-badge&logo=typescript&logoColor=white",
        "https://img.shields.io/badge/Python-14354C?style=for-the-badge&logo=python&logoColor=white",
        "https://img.shields.io/badge/OpenAI-00DAAF?style=for-the-badge&logo=openai&logoColor=white",
      ],
    },
    {
      position: "Full Stack Developer, Intern",
      company: "HackeroX",
      companyLink: "https://hackerox.com/",
      location: "Mumbai",
      dates: "Oct 2023 - Dec 2023",
      responsibilities: [
        "Spearheaded the development of an All-in-one app for Connectors from scratch, streamlining the lead referral process with a sleek and intuitive UI prioritizing user experience.",
        "Implemented a robust Node.js and Express.js backend, seamlessly integrated with AWS features to communicate with Zoho CRM backend. leveraging AWS Pinpoint for authentication and AWS Amplify comprehensive app telemetry.",
        "Weekly builds to clients for rigorous testing and publication on both Android and IOS platforms. Followed the Scrum framework.",
      ],
      image: finzen,
      techUsed: [
        "https://img.shields.io/badge/AWS-%23FF9900.svg?style=for-the-badge&logo=amazon-aws&logoColor=white",
        "https://img.shields.io/badge/React_Native-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
        "https://img.shields.io/badge/Android-3DDC84?style=for-the-badge&logo=android&logoColor=white",
        "https://img.shields.io/badge/iOS-000000?style=for-the-badge&logo=ios&logoColor=white",
        "https://img.shields.io/badge/Node.js-43853D?style=for-the-badge&logo=node.js&logoColor=white",
        "https://img.shields.io/badge/Express.js-000000?style=for-the-badge&logo=express&logoColor=white",
        "https://img.shields.io/badge/Tailwind_CSS-38B2AC?style=for-the-badge&logo=tailwind-css&logoColor=white",
      ],
      android:
        "https://play.google.com/store/apps/details?id=com.finzenindia.finzenconnect&hl=en_US",
      ios: "https://apps.apple.com/in/app/finzen-connect/id6480217756",
    },
    {
      position: "Software Developer, Intern",
      company: "CDAC",
      companyLink: "https://www.cdac.in/index.aspx?id=MB",
      location: "Mumbai",
      dates: "Sep 2022 - Jan 2024",
      responsibilities: [
        "Led a team of 4 to build an interactive virtual lab to help students learn about Basic Proportionality theorem under the Centre for Development of Advanced Computing, India.",
      ],
      image: cdac,
      techUsed: [
        "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
        "https://img.shields.io/badge/Tailwind_CSS-38B2AC?style=for-the-badge&logo=tailwind-css&logoColor=white",
        "https://img.shields.io/badge/html5-%23E34F26.svg?style=for-the-badge&logo=html5&logoColor=white",
        "https://img.shields.io/badge/MaterialUI-08B2CC?style=for-the-badge&logo=material-ui&logoColor=blue",
      ],
      url: "https://cdac-bpt.vercel.app/",
    },
  ];

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      id="experience"
      className="min-h-[700px] mt-6  "
    >
      <div className="pb-3">
        <span className="text-[#64ffda] ml-[8%] text-xl">03. </span>
        <span className="text-gray-200 text-2xl title font-extrabold">
          Experience
        </span>
      </div>
      {/* <div className="container">
        <div id="box1" className="cover atvImg ">
          <div className="atvImg-layer" data-img={rag}></div>
          <div className="atvImg-layer" data-img={rag}></div>
        </div>
        <div id="box4" className="cover atvImg">
          <div className="atvImg-layer" data-img={finzen}></div>
          <div className="atvImg-layer" data-img={finzen}></div>
        </div>

        <div id="box2" className="cover atvImg">
          <div className="atvImg-layer" data-img={cdac}></div>
          <div className="atvImg-layer" data-img={cdac}></div>
        </div>

        <div id="circled"></div>
        <div className="cover atvImg">
          <div
            className="atvImg-layer"
            data-img="http://robindelaporte.fr/codepen/visa-bg-4.jpg"
          ></div>
          <div
            className="atvImg-layer"
            data-img="http://robindelaporte.fr/codepen/visa.png"
          ></div>
        </div>
      </div> */}
      <div className=" pl-2  sm:flex items-center justify-center">
        {experience.map((item, id) => (
          <>
            <MotionFromRight key={id}>
              <div className="w-[96%] ml-1   rounded-2xl hover:sm:shadow-cyan-950 hover:ease-in-out transition duration-1000 ease-in-out hover:transition hover:duration-1000 hover:shadow-[0_5px_50px_5px_rgba(0,0,0,0.1)] title group">
                <div
                  id={`box${id}`}
                  className="cover atvImg w-96"
                  onMouseEnter={() => setIsHoveredImg(true)}
                  onMouseLeave={() => setIsHoveredImg(false)}
                >
                  <div className="atvImg-layer" data-img={item.image}></div>
                  <div className="atvImg-layer" data-img={item.image}></div>
                </div>

                <div className="flex flex-col px-6 justify-between items-start  relative  z-20">
                  <div className="text-gray-200 rounded-md flex items-center justify-between w-full font-semibold z-20 bg-[#0a192f]/70 backdrop-blur-md text-xl p-1">
                    {item.position}{" "}
                    {item?.android && (
                      <span className=" text-white ml-1 text-3xl hover:text-[#64ffda]">
                        <a
                          href={item?.android}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <IoLogoGooglePlaystore />
                        </a>
                      </span>
                    )}
                    {item?.ios && (
                      <span className=" text-white ml-1 text-3xl hover:text-[#64ffda]">
                        <a
                          href={item?.ios}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <IoLogoAppleAppstore />
                        </a>
                      </span>
                    )}
                    {item?.url && (
                      <span className=" text-white ml-1 text-3xl hover:text-[#64ffda]">
                        <a
                          href={item?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <AiOutlineLink />
                        </a>
                      </span>
                    )}
                  </div>
                  <div className="bg-[#112240]/80 backdrop-blur-md text-[#a3a9bd] relative  px-6 py-3 rounded-md  gap-1 items-end text-start">
                    <a className="hover:text-[#64ffda]" href={item.companyLink}>
                      {item.company}
                    </a>
                    ,{" "}
                    <span className="text-sm text-white/80">
                      {item.location}
                    </span>
                    , <span className=" text-sm">{item.dates}</span>
                  </div>
                  <div className="sm:absolute block left-5 right-full w-[90%] sm:mt-0 mt-3 h-full sm:transition-all ease-in-out duration-1000 transform sm:opacity-0 sm:group-hover:opacity-100  sm:group-hover:translate-y-[150px]">
                    <div className="bg-[#112240]/80 backdrop-blur-md text-[#c3c7d2] relative text-sm px-6 py-3 rounded-md text-start">
                      {item.responsibilities[0]}
                    </div>
                  </div>
                  <div className="flex bg-[#0a192f] no-scrollbar mb-3 overflow-x-auto rounded-xl p-1 mt-4">
                    {item.techUsed?.map((tech, index) => (
                      <img
                        key={index}
                        src={tech}
                        alt=""
                        className=" w-max flex mx-1"
                      ></img>
                    ))}
                  </div>
                  {/* <div className="flex">
                <span className="m-3 text-gray-300 text-3xl hover:text-[#64ffda]">
                  <a
                    href={githubLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <AiFillGithub />
                  </a>
                </span>
                <span className="m-3 text-gray-300 text-3xl hover:text-[#64ffda]">
                  <a
                    href={projectLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <AiOutlineLink />
                  </a>
                </span>
              </div> */}
                </div>
              </div>
            </MotionFromRight>
          </>
        ))}
        {isHovered && <div id="circled"></div>}
      </div>
    </div>
  );
};

export default Experience;
